module.exports = __webpack_public_path__ + "img/icon_ticket.62d3dfd4.svg";